import React, { useState } from 'react'
import { observer } from 'mobx-react'
import Modal from './Modal'

export default observer(({ report }) => {
    if (!report?.needsUpdate) return null
    return (
        <div
            className="text-center p-8 flex justify-center items-start"
            style={{
                background: '#FFFFFFaa',
                zIndex: 900,
                width: '100vw',
                height: '100vh',
                position: 'absolute',
                left: 0,
                marginTop: '-2rem',
                minHeight: '15rem',
            }}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    width: '20rem',
                    height: '13rem',
                    display: 'inline-flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '1rem',
                    boxShadow: '0 0 2rem #00000033',
                    marginTop: '2rem',
                }}
            >
                <h4>Apply Changes To Report</h4>
                <button
                    className="btn btn-primary"
                    onClick={() => report.setQueryKey()}
                    style={{ marginTop: '2rem' }}
                >
                    Update Report
                </button>
            </div>
        </div>
    )
})
